import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { connectToStore } from '../../store';
import styles from './Reports.module.scss';
import ReportsList from './reports-list/ReportsList';
import ReportEditor from './report-editor/ReportEditor';
import NotFound from '../not-found/NotFound';

const subRoutes = [
	{
		path: `/`,
		exact: true,
		component: ReportsList,
	},
	{
		path: `/:category/:id`,
		exact: true,
		component: ReportEditor,
	},
];

function Reports() {
	const { path } = useRouteMatch();
	return (
		<div className={styles.screen}>
			<Switch>
				{/* Routes */}
				{subRoutes.map((route, index) => (
					<Route key={index} path={`${path}${route.path}`} exact={route.exact}>
						<route.component />
					</Route>
				))}

				{/* 404 */}
				<Route path="*">
					<NotFound />
				</Route>
			</Switch>
		</div>
	);
}

export default connectToStore(Reports);
